type EventName =
  | 'track.started'
  | 'track.ready'
  | 'track.completed'
  | 'track.challenge_started'
  | 'track.challenge_completed'
  | 'track.challenge_skipped'
  | 'track.user_clicked_finish'
  | 'invite.form_submitted';

interface EventParams {
  track_slug?: string;
  team_name?: string;
  challenge_slug?: string;
  total_challenges?: number;
  invite_id?: string;
}

function embedEvent(name: 'invite.form_submitted', params: { invite_id: string; track_slug: string }): void;
function embedEvent(name: 'track.started', params: { track_slug: string; total_challenges: number }): void;
function embedEvent(name: 'track.ready', params: { track_slug: string; team_name: string }): void;
function embedEvent(name: 'track.challenge_started', params: { track_slug: string; challenge_slug: string }): void;
function embedEvent(name: 'track.completed', params: { track_slug: string; total_challenges: number }): void;
function embedEvent(
  name: 'track.challenge_completed',
  params: { track_slug: string; challenge_slug: string; total_challenges: number },
): void;
function embedEvent(name: 'track.challenge_skipped', params: { track_slug: string; challenge_slug: string }): void;
function embedEvent(name: 'track.user_clicked_finish'): void;

function embedEvent(name: EventName, params?: EventParams): void {
  const parent = window.parent || window.opener;
  if (parent) {
    parent.postMessage({ event: name, params: params }, '*');
  }
}

export default embedEvent;
